exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icone-pdf[data-v-71ba4a74] {\n    font-size: 2.5rem;\n}\n", ""]);

// exports
